<div class="overLayDiv active"></div>
<div id="rightSideBar">
    <div class="rightSidePanel w-60pc active" style="z-index:99999;">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{'text_associate' | translate:param}}</h2>
            </div>            
            <div class="panel-left-btn">
                <button type="button" class="btn eod-btn-outline-warning" (click)="fnClosePanel()">
                    {{ 'label_close' | translate: param }}
                </button>
            </div>
        </header>
        <div class="eod-panel-body-with-footer">
            <div class="block mt-2" *ngIf="(claimantAssociatedExpenseList).length === 0">
                <p class="text-center noDataAvailable disabled opacity-60">
                    {{ "no_data_available" | translate: param }}</p>
            </div>
            <div class="block mt-2 padding-top-30" *ngFor="let item of claimantAssociatedExpenseList">
                <table class="table border-bottom">
                    <thead>
                        <tr>
                            <th width="25%">
                                <span>
                                    <input type="radio" name="terms" class="svg-20 margin-right-10 align-middle"
                                        [(ngModel)]="selectedExpenseId" [value]="item.expenseId"
                                        (change)="fnOnExpenseChange(item.expenseId.expenseId);this.hasFormChanges= true;">
                                </span>

                                {{'text_category' | translate:param}}
                            </th>
                            <th width="12%">{{'ExpenseDate' | translate:param}}</th>
                            <th class="text-right padding-right-30" width="18%">{{'text_amount' | translate:param}}
                                ({{ this.fnGetCurrencyCode(item.currencyId)}})</th>
                            <th width="25%">{{'text_supplier' | translate:param}}</th>
                            <th width="25%">{{'text_notes' | translate:param}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td width="25%" class="text-ellipsis">{{this.inputData.expenseCategoryName}}</td>
                            <td class="text-ellipsis"> {{ this.datePipe.transform(item.expenseDate) }}</td>
                            <td class="text-right padding-right-30 text-ellipsis">
                                {{ item.amount | number: "1.2-2" | noComma }}
                            </td>
                            <td class="text-ellipsis">{{item.supplier}}</td>
                            <td class="text-left text-ellipsis">{{item.notes}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <footer class="mt-auto py-1 d-flex justify-content-center align-items-center gap-2 height-60px" *ngIf="(claimantAssociatedExpenseList).length > 0">
            <button type="button" class="btn eod-btn-primary" [ngClass]="{ disabled: !selectedExpenseId || !this.hasFormChanges }"
                (click)="fnSelectAssociateCreditCardExpense()">
                {{'text_associate' | translate:param}}
            </button>
        </footer>
    </div>
</div>
